import axios from 'axios';
import { getAuth } from 'firebase/auth';
import config from 'config';

const apiUrl = config.apiUrl;

// Fetch time-based review aggregation data for charts
export const fetchTimeBasedReviewAggregation = async (taskId, period = 'month', startDate = null, endDate = null) => {
  console.log('fetchTimeBasedReviewAggregation called with:', { taskId, period, startDate, endDate });

  if (!taskId) {
    console.error('Task ID is required but was not provided');
    throw new Error('Task ID is required');
  }

  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    console.error('No authenticated user found');
    throw new Error('No authenticated user found');
  }

  try {
    // Build query parameters
    const params = { period };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    // Get token
    const token = await user.getIdToken();

    // Make API request
    const response = await axios.get(`${apiUrl}/analysis_projects/time_aggregation/${taskId}`, {
      params,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    });

    console.log('API response received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching time-based review aggregation:', error);
    if (error.response) {
      console.error('Response error data:', error.response.data);
      console.error('Response error status:', error.response.status);
    }
    throw error;
  }
};
